var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, memo, useContext, useMemo, useState } from "react";
import { defineProperties } from "../../translationService";
import createEntityScreen from "../layout/connectedEntityScreen";
import i18next from "i18next";
import { getClassName } from "../../helpers";
import { TABLE_BODY_CELL, TABLE_BODY_CELL_LINK, TABLE_BODY_CELL_SPAN, TABLE_BODY_DESCRIPTION_ROW, TABLE_BODY_ROW, TABLE_BODY_ROW_EXPANDED, TABLE_CELLS, USER_NEEDS_TO_PAY, USER_NEXT_APPOINTMENT, } from "../../classConstants";
import parse, { attributesToProps } from 'html-react-parser';
import { SvgIcon } from "../../icons";
import styled from "styled-components";
import { Button } from "../../components/Form";
import { useTranslation } from "react-i18next";
import { Flex } from "../../components/Flex";
import { useSelector } from "react-redux";
import { getUserEntity } from "../../store/actions/response.actions";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { AppointmentsList } from "../../components/Courses/Appointments";
import { ECourseColumns } from "../../store/store";
var StyledSvg = styled(SvgIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: var(--ws-entity-action-icon-width, 1em);\n    height: var(--ws-entity-action-icon-width, 1em);\n"], ["\n    width: var(--ws-entity-action-icon-width, 1em);\n    height: var(--ws-entity-action-icon-width, 1em);\n"])));
var RemoveIcon = styled(StyledSvg)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: auto;\n    display: block;\n"], ["\n    margin-left: auto;\n    display: block;\n"])));
var DownloadIcon = styled(StyledSvg)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n"], ["\n"])));
var StyledAnchor = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-flex;\n    gap: .5em;\n"], ["\n    display: inline-flex;\n    gap: .5em;\n"])));
var UserSummary = styled.h3(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: var(--ws-user-summary-gap, .5em);\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: var(--ws-user-summary-gap, .5em);\n"])));
var NextAppointment = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n"], ["\n"])));
var BalanceAmountPending = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    .", "-amount {\n        color: var(--ws-user-requires-payment-color, var(--ws-danger-text));\n    }\n"], ["\n    .", "-amount {\n        color: var(--ws-user-requires-payment-color, var(--ws-danger-text));\n    }\n"])), USER_NEEDS_TO_PAY);
var parseHtml = function (html) {
    return parse(html, {
        trim: true,
        htmlparser2: { lowerCaseTags: false, },
        replace: function (domNode) {
            var _a, _b;
            var props = domNode.attribs ? attributesToProps(domNode.attribs) : {};
            var icons = {
                'removeicon': function () { return React.createElement(RemoveIcon, __assign({}, props, { type: "notallowed" })); },
            };
            return (_b = icons[(_a = domNode.name) !== null && _a !== void 0 ? _a : '']) === null || _b === void 0 ? void 0 : _b.call(icons);
        },
    });
};
var RenderBillRow = function (props) {
    var t = useTranslation().t;
    var downloadLabel = useMemo(function () {
        return parseHtml(t("user_entity.bookings.download_bill", {
            billId: props.billId,
            icon: ""
        }));
    }, [t, props.billId]);
    return (React.createElement(StyledAnchor, { leftIcon: React.createElement(DownloadIcon, { type: "download" }), title: t("user_entity.bookings.download_bill_title", { billId: props.billId, defaultValue: "" }), href: props.downloadLink, variant: "clear", className: getClassName(TABLE_BODY_CELL_LINK, 'ws-download-bill-button', "ws-bill-status-" + props.status) }, downloadLabel));
};
var BookingScreenHeader = memo(function () {
    var t = useTranslation().t;
    var entities = useSelector(function (state) {
        var _a;
        return (_a = getUserEntity(state.responseReducer, { entity: 'bookings' })) === null || _a === void 0 ? void 0 : _a.response;
    });
    var _a = useMemo(function () {
        var _a, _b, _c;
        var user = getResponseManager(entities).user();
        var amount = (_b = (_a = user === null || user === void 0 ? void 0 : user.getUserInfo()) === null || _a === void 0 ? void 0 : _a.dueAmount) !== null && _b !== void 0 ? _b : null;
        var appointment = (_c = user === null || user === void 0 ? void 0 : user.findNextAppointment('user_entity.bookings')) !== null && _c !== void 0 ? _c : null;
        return {
            dueAmount: amount && parse(t("user_entity.bookings.summary.due_amount", {
                dueAmount: "<span class=\"" + USER_NEEDS_TO_PAY + "-amount\">" + amount + "</span>"
            })),
            nextAppointment: appointment && parse(t("user_entity.bookings.summary.next_appointment", {
                title: "<span class=\"" + USER_NEXT_APPOINTMENT + "-name\">" + appointment.title + "</span>",
                dateTime: "<span class=\"" + USER_NEXT_APPOINTMENT + "-date\">" + appointment.at + "</span>"
            }))
        };
    }, [entities]), dueAmount = _a.dueAmount, nextAppointment = _a.nextAppointment;
    if (!dueAmount && !nextAppointment)
        return null;
    return React.createElement(UserSummary, null,
        nextAppointment && React.createElement(NextAppointment, { className: USER_NEXT_APPOINTMENT }, nextAppointment),
        dueAmount && React.createElement(BalanceAmountPending, { className: USER_NEEDS_TO_PAY }, dueAmount));
});
var RowCollapsedContext = createContext(null);
var DescriptionCell = function (props) {
    if (!props.showDescription)
        return null;
    var rowClassName = getClassName(TABLE_BODY_ROW, TABLE_BODY_DESCRIPTION_ROW);
    var cellClassName = getClassName(TABLE_BODY_CELL, TABLE_CELLS[ECourseColumns.DESCRIPTION]);
    return (React.createElement("tr", { className: rowClassName },
        React.createElement("td", { className: cellClassName, colSpan: props.columnCount }, parse(props.data['infolink'] || ''))));
};
var BookingsRow = memo(function (_a) {
    var _b;
    var EntityRow = _a.EntityRow, props = __rest(_a, ["EntityRow"]);
    var state = useState(false);
    var showDescription = state[0];
    var className = getClassName(props.className, (_b = {},
        _b[TABLE_BODY_ROW_EXPANDED] = showDescription,
        _b));
    return React.createElement(RowCollapsedContext.Provider, { value: state },
        React.createElement(EntityRow, __assign({}, props, { className: className })),
        React.createElement(DescriptionCell, { showDescription: showDescription, columnCount: props.columnHeaders.length, data: props.data }));
});
var InfoCell = function () {
    var t = useTranslation().t;
    var _a = useContext(RowCollapsedContext), toggleAction = _a[1];
    return (React.createElement("a", { className: TABLE_BODY_CELL_LINK, href: "#", onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleAction(function (opened) { return !opened; });
        } }, t('user_entity.bookings.more_info')));
};
export var bookingScreenColumns = [
    defineProperties({ key: "bookingid", }, { label: 'user_entity.bookings.booking_id', }),
    defineProperties({ key: "fullname", }, { label: 'user_entity.bookings.full_name', }),
    defineProperties({ key: "course", }, { label: 'user_entity.bookings.course', }),
    defineProperties({ key: "bills", }, { label: 'user_entity.bookings.bills', }),
    defineProperties({ key: "timespan", visible: false }, { label: 'user_entity.bookings.timespan', }),
    defineProperties({ key: "place", }, { label: 'user_entity.bookings.place', }),
    defineProperties({ key: "appointments", visible: false }, { label: 'user_entity.bookings.appointments', }),
    defineProperties({ key: "appointmentlist", }, { label: 'user_entity.bookings.appointment_list', }),
    defineProperties({ key: "info", visible: false }, { label: 'user_entity.bookings.information', }),
    { key: "infolink", label: "" },
    defineProperties({ key: "dueamount", align: 'right' }, { label: 'user_entity.bookings.due_amount', }),
    defineProperties({ key: "cancellink", align: "right" }, { label: 'user_entity.bookings.cancel_link', }),
];
export var UserBookingsScreen = createEntityScreen({
    entityName: 'bookings',
    EntityRow: BookingsRow,
    columnConfiguration: "userBookingsColumns",
    ScreenHeader: BookingScreenHeader,
    columnHeaders: bookingScreenColumns,
    getRecordClassName: function (record) {
        var _a, _b;
        return getClassName((_a = record.tagNames) === null || _a === void 0 ? void 0 : _a.map(function (tagName) { return "ws-tags-" + tagName; }), (_b = record.courseNames) === null || _b === void 0 ? void 0 : _b.map(function (tagName) { return "ws-course-" + tagName; }));
    },
    renderCell: function (record, column, wrapFunction) {
        switch (column) {
            case 'infolink':
                return record[column] && React.createElement(InfoCell, null);
            case "course":
                return record[column] && wrapFunction(parse(record[column]));
            case "appointments":
            case "appointmentlist":
                return record[column] && React.createElement(AppointmentsList, { className: TABLE_BODY_CELL_SPAN, data: record[column], placement: "user_entity.bookings" });
            case "bills": {
                var bills = record[column];
                if (!Array.isArray(bills) || !bills.length)
                    return null;
                return wrapFunction(React.createElement(Flex, { isInline: false }, bills.map(function (bill) { return React.createElement(RenderBillRow, __assign({ key: bill.billId }, bill)); })));
            }
            case "cancellink": {
                if (!record[column])
                    return null;
                var cancelLabel = parseHtml(i18next.t("user_entity.bookings.cancel_booking_button", { icon: "<RemoveIcon title=\"" + i18next.t("user_entity.bookings.cancel_booking", { defaultValue: "" }) + "\"></RemoveIcon>" }));
                return (React.createElement(StyledAnchor, { variant: "clear", title: i18next.t("user_entity.bookings.cancel_booking", { defaultValue: "" }), className: getClassName(TABLE_BODY_CELL_LINK, "ws-booking-cancel-button"), href: record[column] }, cancelLabel));
            }
        }
        return wrapFunction(record[column]);
    },
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
